import type { ComponentProps, ReactElement } from "react"
import { UserButton } from "@clerk/react"
import { useMeStore } from "@/features/auth/hooks/useCurrentUser"
import { SubscriptionPanel } from "./SubscriptionPanel"

type UserButtonProps = ComponentProps<typeof UserButton>

const subscriptionIcon: ReactElement = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
  </svg>
)

/** Clerk's UserButton, plus a Subscription page and menu entry when billing is enabled. */
export function AccountButton(props: UserButtonProps) {
  // Read the store, not useCurrentUser: that hook needs a ClerkProvider, which callers already have.
  const billingEnabled = useMeStore((s) => s.me?.billing_enabled === true)
  if (!billingEnabled) return <UserButton {...props} />
  return (
    <UserButton {...props}>
      <UserButton.MenuItems>
        <UserButton.Action label="Subscription" labelIcon={subscriptionIcon} open="subscription" />
      </UserButton.MenuItems>
      <UserButton.UserProfilePage label="Subscription" url="subscription" labelIcon={subscriptionIcon}>
        <SubscriptionPanel />
      </UserButton.UserProfilePage>
    </UserButton>
  )
}
